import React, { Fragment } from "react";
import { Input, FormFeedback, FormText } from "reactstrap";

export const renderTextField = ({
  input,
  meta: { touched, error, warning },
  ...custom
}) => (
  <Fragment>
    <Input {...(touched ? { valid: !error } : {})} {...input} {...custom} />
    {error && <FormFeedback>{error}</FormFeedback>}
    {!error && warning && <FormText>{warning}</FormText>}
  </Fragment>
);

export const renderSelectField = ({
  input,
  options,
  placeholder
}) => (
  <Fragment>
    <select className="custom-select" placeholder={placeholder} {...input}>
      <option value={0}>Please select instance</option>
      {options.map(option => (
        <option key={option.UID_Instance} value={option.UID_Instance}>
          {option.Name_Instance}
        </option>
      ))}
    </select>
  </Fragment>
);
renderSelectField.defaultProps = {
  options: []
};

export const renderSelectFieldTwo = ({
  input,
  options,
  placeholder
}) => (
  <Fragment>
    <select className="custom-select" placeholder={placeholder} {...input}>
      <option value={0}>Please select partner</option>
      {options.map(option => (
        <option key={option.UID_Partner} value={option.UID_Partner}>
          {option.Name_Partner}
        </option>
      ))}
    </select>
  </Fragment>
);

export const renderSelectFieldThree = ({
  input,
  options,
  placeholder
}) => (
  <Fragment>
    <select className="custom-select" placeholder={placeholder} {...input}>
      <option value={0}>Select code</option>
      {options.map(option => (
        <option key={option.UID_Country} value={option.Calling_Code}>
          +{option.Calling_Code}
        </option>
      ))}
    </select>
  </Fragment>
);
renderSelectField.defaultProps = {
  options: []
};

export const renderTeamsDataSelectField = ({
  input,
  options,
  placeholder
}) => (
  <Fragment>
    <select className="custom-select" placeholder={placeholder} {...input}>
      <option value={0}>Please select Customer Team</option>
      {options.map(option => (
        <option key={option.UID_Team} value={option.UID_Team}>
          {option.Name_Team}
        </option>
      ))}
    </select>
  </Fragment>
);
